import { TypographyV3 } from '@jouzen/ecom-components';
import type { ReactNode } from 'react';

interface Props {
  readonly className?: string;
  readonly children: ReactNode;
  readonly small?: boolean;
}

const Subtitle = ({
  className,
  children,
  small,
  ...props
}: Props): JSX.Element => (
  <TypographyV3
    data-cy="lp-subtitle"
    Element="p"
    variant={small ? 'h6' : 'h4'}
    color="inherit"
    className={className!}
    {...props}
  >
    {children}
  </TypographyV3>
);

export default Subtitle;
